export default __webpack_public_path__ + "static/media/GammeLogic.fa055e45.png";